import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import App from './components/App/App';
import awsconfig from './aws-exports';
import './i18n';
import reportWebVitals from './reportWebVitals';

import './index.css';
import '@aws-amplify/ui-react/styles.css';

// Configure Amplify before any Auth call. picksApi.ts pulls the active
// Cognito session via Auth.currentSession() to attach as Bearer token.
Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Authenticator.Provider>
        <App />
      </Authenticator.Provider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
